import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { Map } from 'immutable';
import moment from 'moment';
import { ReportActions } from '../../../actions/report';
import { ModalActions } from '../../../actions/modal';

import BasicCreateButton from '../../../components/buttons/BasicCreateButton/';
import DailyTaskItem from './DailyTaskItem';

// import ElementTypeCard from '../../cards/ElementTypeCard';
// import '../../../styles/ElementTypeDefaultTab.css';

class DailyTasksCompleteList extends Component {
  static propTypes = {
    currentProjectId: PropTypes.string,
    dispatch: PropTypes.func.isRequired,
    icons: PropTypes.instanceOf(Map),
    reports: PropTypes.instanceOf(Map),
    user: PropTypes.instanceOf(Map),
    userMode: PropTypes.string,
  }

  confirmDelete = (reportId) => {
    const { dispatch, reports } = this.props;

    const reportToDelete = reports.get(reportId);

    const name = reportToDelete.get('name');

    dispatch(ModalActions.toggleModal({
      name: 'DeleteConfirmationModal',
      options: {
        deleteType: 'dailyTaskCompleteReport',
        handleDelete: this.handleDelete.bind(this, reportId),
        name,
      },
    }));
  }

  handleDelete = (reportId) => {
    const { currentProjectId, dispatch } = this.props;

    dispatch(ReportActions.deleteReport(reportId, currentProjectId));
  }

  toggleModal = () => {
    const { dispatch } = this.props;

    dispatch(ModalActions.toggleModal({
      name: 'CreateDailyTaskCompleteReportModal',
    }));
  }

  renderDailyTaskList = () => {
    const { reports } = this.props;

    if (!reports) {
      return <div />;
    }
    return reports.valueSeq().sortBy(o => - parseInt(o.get('id'), 10)).map(v =>
      <DailyTaskItem
        key={v.get('id')}
        id={v.get('id')}
        name={v.get('name')}
        createdAt={moment(v.get('created_at'))}
        onDelete={this.confirmDelete}
      />
    );
  }

  render() {
    const { userMode } = this.props;
    const adminMode = (userMode !== 'reader' && userMode !== 'user');

    const createReportButton = (adminMode) ?
    (
      <BasicCreateButton
        className="btn btn-primary btn-sm"
        onClick={this.toggleModal}
        style={{ marginBottom: 5 }}
      >
        <i className="fa fa-plus"></i> New Daily Task Complete Report
      </BasicCreateButton>
    ) : null;

    return (
      <div className="row tab-content-wrapper">
        <div className="col-md-12 project-default-left-col">
          <h2>
            <span>Daily Task Complete Reports</span>
          </h2>
          {createReportButton}
          <div className="row">
            {this.renderDailyTaskList()}
          </div>
        </div>
      </div>
    );
  }
}

export default DailyTasksCompleteList;



// WEBPACK FOOTER //
// ./src/views/ProjectSettings/DailyTasksCompleteList/DailyTasksCompleteList.js